import Quill from 'quill-next';

const Block = Quill.import('blots/block') as any;

export class ListeningArticleCnBlock extends Block {
  static blotName = 'listening-article-cn';
  static className = 'ql-l-article-cn';
  static tagName = 'div';

  static create(value: any) {
    return super.create(value);
  }

  show() {
    this.domNode.dataset.visible = 'true';
  }

  hide() {
    this.domNode.dataset.visible = '';
  }
}
